import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  alertDialog: {
    margin: '0 auto',
    padding: '2px',
    position: 'relative',
    alignItems: 'center',
  },
  appLogoDiv: {
    padding: '20px 20px 0 20px',
    textAlign: 'center',
  },
  appLogo: {
    height: '96px',
  },
  loaderMessage: {
    height: '20%',
    padding: '20px 20px 0 20px',
    textAlign: 'center',
    fontSize: '16px',
    color: '#333',
  },
  loaderBar: {
    height: '3px',
  },
}));
